<template>
    <div id="uploadnews">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    
            <el-form-item label="新闻类型" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择新闻类型">
                    <el-option v-for="t in newsTypes" :key="t.id" :label="t.id + '.' + t.name" :value="String(t.id)"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="新闻标题" prop="title">
                <el-input type="textarea" v-model="ruleForm.title"></el-input>
            </el-form-item>

            <vue-ueditor-wrap v-model="ruleForm.content" :config="myConfig"></vue-ueditor-wrap>

            <el-form-item prop="author">
                <label slot="label">作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者</label>
                <el-input v-model="ruleForm.author" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="图片链接" prop="pic">
                <el-input v-model="ruleForm.pic" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="锁定新闻" prop="locked">
                <el-switch v-model="ruleForm.locked"
                :inactive-value="0"
                :active-value="1"
                :disabled="!isAdminFlag"
                ></el-switch>
                <span v-if="!isAdminFlag" style="font-size:12px;color:#999;margin-left:10px;">锁定需管理员授权</span>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">立即修改</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap';
import { NEWS_TYPES } from '@/constants/newsTypes';
import { request } from '@/api/http';

export default {
    components: {
        VueUeditorWrap,
    },
    data () {
        return {
            newsTypes: NEWS_TYPES,
            ruleForm: {
                "author": "","content": "","id": '', "locked": '',"pic": "","time": "","title": "","type": ''
            },
            rules: {
                type: [
                    { required: true, message: '请选择新闻类型', trigger: 'change' }
                ],
                title: [
                    { required: true, message: '请填写新闻标题', trigger: 'blur' },
                    { max: 200, message: '长度少于 200 个字符', trigger: 'blur' }
                ],
                author: [
                    {  },
                ],

            },
            // 当前登录用户
            isAdminFlag: sessionStorage.getItem('isAdmin') === '1',

            //新闻编辑器
            // msg: '',
            myConfig: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: true,
                // 初始容器宽度
                initialFrameWidth: 1083,
                // 初始容器高度
                initialFrameHeight: 600,
                UEDITOR_HOME_URL: 'UEditor/',
                // 上传文件接口
                serverUrl: '/UEditor/php/controller.php'
            },
        };
    },

  computed: {
    //为了监听msg数据的变化
    listenstore() {
      return this.ruleForm.content;
    }
  },

  watch: {
    listenstore: function () {
      //取正文第一张图片作为缩略图
      const picPath = (this.ruleForm.content.split('<img src="')[1] || '').split('" title="')[0];
      this.ruleForm.pic = picPath;
    },
  },

    mounted () {
        this.getnewes();
    },
    methods: {
        getnewes(){
            request('/CalawaEnServlet/NewsServlet', {
                action: 'getNewsInfoById',
                id: this.$route.params.id,
            })
            .then(response=> {
                const d = response.data;
                this.ruleForm.author = d.author;
                this.ruleForm.content = d.content;
                this.ruleForm.id = d.id;
                this.ruleForm.locked = d.locked;
                this.ruleForm.pic = d.pic;
                this.ruleForm.time = d.time;
                this.ruleForm.title = d.title;
                this.ruleForm.type = String(d.type);
            }).catch(()=> {
                this.$message.error('Failed to load the news');
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false;
                }
                request('/CalawaEnServlet/NewsServlet', {
                    action: 'updateNews',
                    type: this.ruleForm.type,
                    title: this.ruleForm.title,
                    content: this.ruleForm.content,
                    pic: this.ruleForm.pic,
                    author: this.ruleForm.author,
                    locked: this.ruleForm.locked,
                    id: this.ruleForm.id,
                    username: sessionStorage.getItem('loginin') || '',
                    isAdmin: this.isAdminFlag ? 1 : 0,
                }, 'post').then(()=> {
                    this.$router.push({ name: 'listnews', params: { type: 0, page: 1 }});
                }).catch(error=> {
                    console.log(error);
                });
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
}
</script>

<style lang="scss" scoped>
#uploadnews{
    width:1083px;
    margin: 0 auto;

    .el-form{
        width: 460px;

        text-align: left;

        // margin-top: 30px;

        div:nth-child(3){
            width: 1083px;

            margin: 20px 0 30px 0;
        }
    }
}
</style>